import { render, staticRenderFns } from "./ordercomments.vue?vue&type=template&id=4720db09&"
import script from "./ordercomments.vue?vue&type=script&lang=js&"
export * from "./ordercomments.vue?vue&type=script&lang=js&"
import style0 from "./ordercomments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports